import React from 'react';

type QuoteProps = {
   html: string
}

const Quote: React.FC<QuoteProps> = ({ html }) => (
   <p className="quote text-gray-300 font-serif p-1 lg:p-4 max-w-2xl"
      dangerouslySetInnerHTML={{
         __html: html
      }}>
   </p>
)

export default Quote;